import { tw } from '@/utils/tw';

export const getReturnColorClass = (returnValue: number) => {
  if (returnValue > 0) {
    return tw`text-success`;
  }

  if (returnValue < 0) {
    return tw`text-destructive`;
  }

  return tw`text-foreground`;
};
